import { createContext } from 'react';

export const ConfettiContext = createContext({
  confettiCounter: 0,
  setConfettiCounter: () => null,
});
